var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraggable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "60px",
    viewBox: "0 0 38 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EA112212-ABE6-43A0-A209-CE05A6F96C03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Putanja-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Saved-Itineraries-1-Copy-2",
    transform: "translate(-1161.000000, -376.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(121.500000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.500000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "draggable",
    transform: "translate(1039.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7,11.25 C8.848034,11.25 11.4,8.7316125 11.4,5.625 C11.4,2.5183875 8.848034,0 5.7,0 C2.551966,0 0,2.5183875 0,5.625 C0,8.7316125 2.551966,11.25 5.7,11.25 Z M5.7,35.625 C8.848034,35.625 11.4,33.1065 11.4,30 C11.4,26.8935 8.848034,24.375 5.7,24.375 C2.551966,24.375 0,26.8935 0,30 C0,33.1065 2.551966,35.625 5.7,35.625 Z M11.4,54.375 C11.4,57.4815 8.848034,60 5.7,60 C2.551966,60 0,57.4815 0,54.375 C0,51.2685 2.551966,48.75 5.7,48.75 C8.848034,48.75 11.4,51.2685 11.4,54.375 Z M32.3,11.25 C35.44792,11.25 38,8.7316125 38,5.625 C38,2.5183875 35.44792,0 32.3,0 C29.15208,0 26.6,2.5183875 26.6,5.625 C26.6,8.7316125 29.15208,11.25 32.3,11.25 Z M38,30 C38,33.1065 35.44792,35.625 32.3,35.625 C29.15208,35.625 26.6,33.1065 26.6,30 C26.6,26.8935 29.15208,24.375 32.3,24.375 C35.44792,24.375 38,26.8935 38,30 Z M32.3,60 C35.44792,60 38,57.4815 38,54.375 C38,51.2685 35.44792,48.75 32.3,48.75 C29.15208,48.75 26.6,51.2685 26.6,54.375 C26.6,57.4815 29.15208,60 32.3,60 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggable);
export default __webpack_public_path__ + "static/media/draggable.e404084bc1da96a395b50bae43a6cc67.svg";
export { ForwardRef as ReactComponent };